import { defineComponent as _defineComponent } from 'vue';
import { SLogo } from '@strana-artw/ui-kit';
import { computed, defineComponent } from 'vue';
import Logo20Component from '@/shared/ui/Logo20Component.vue';
import { useFeatureFlagsStore } from '@/store/featureFlags';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheLogo',
  setup: function setup(__props) {
    defineComponent({
      name: 'TheLogo'
    });
    var featureFlagsStore = useFeatureFlagsStore();
    var isLogo20 = computed(function () {
      return featureFlagsStore.isLogo20();
    });
    return {
      __sfc: true,
      featureFlagsStore: featureFlagsStore,
      isLogo20: isLogo20,
      SLogo: SLogo,
      Logo20Component: Logo20Component
    };
  }
});